import React from "react";
import { SkinProvider, useSkin } from "../skins/SkinContext";
import { getSkin } from "../skins/skins";
import type { SkinId } from "../skins/types";
import { SkRect } from "../prim";
import { skSun, skTree, skPerson } from "../actors3";
import { skDog } from "../actors3/animals";

/** A tiny skin-aware sample so each card previews the actual illustration style. */
const MiniSample: React.FC = () => {
  const skin = useSkin();
  const g = 96;
  return (
    <g>
      <rect width={200} height={120} fill={skin.surface} />
      <SkRect x={0} y={g} w={200} h={120 - g} fill="#86efac" seed={5} />
      {skSun(34, 30, 1.4, 0.55)}
      {skTree(56, g, 1.4, 0.7)}
      {skPerson(120, g, 1.4, 1.0)}
      {skDog(165, g, 1.4, 0.7)}
    </g>
  );
};

const OPTIONS: { id: SkinId; label: string; note: string }[] = [
  { id: "studio", label: "Studio", note: "clean vector" },
  { id: "handdrawn", label: "Hand-drawn", note: "sketchy ink" },
  { id: "flat", label: "Flat", note: "flat fills" },
  { id: "doodle", label: "Doodle", note: "bold doodle" },
];

export interface SkinPickerProps {
  value: SkinId;
  onChange: (id: SkinId) => void;
}

export const SkinPicker: React.FC<SkinPickerProps> = ({ value, onChange }) => (
  <div className="style-picker">
    <div className="style-picker-label">Choose an illustration style</div>
    <div className="style-picker-row">
      {OPTIONS.map((o) => {
        const selected = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            className={`style-card${selected ? " selected" : ""}`}
            onClick={() => onChange(o.id)}
            aria-pressed={selected}
            title={`${getSkin(o.id).label} — ${o.note}`}
          >
            <svg className="style-card-preview" viewBox="0 0 200 120" preserveAspectRatio="xMidYMid slice">
              <SkinProvider skin={getSkin(o.id)}><MiniSample /></SkinProvider>
            </svg>
            <span className="style-card-label">{o.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);
